module.exports = __webpack_public_path__ + "img/1.c923a4d8.jpg";